// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2YGNk","header":"ReportDetails_header__3r8hm","title":"ReportDetails_title__3z1zA","left":"ReportDetails_left__3OR2s"};